import { Outlet } from 'react-router-dom';

const ApiLayout = () => {
  return <Outlet />;
};

export default ApiLayout;
